import Vue from "vue";
import SchoolStatus from "@/components/SchoolStatus.vue";
import Phone from "@/components/Phone.vue";
import CompanySearch from "@/components/CompanySearch.vue";
import SchoolSearch from "@/components/school-search/SchoolSearch.vue";
import CompanyFilters from "@/components/CompanyFilters.vue";
import Empty from "@/components/Empty";
import Pagination from "@/components/parts/Pagination.vue";
import Submenu from "@/components/parts/Submenu.vue";
import Search from "@/components/search/Search";
import Flag from "@/components/Flag";

Vue.component("flag", Flag);
Vue.component("submenu", Submenu);
Vue.component("school-status", SchoolStatus);
Vue.component("pagination", Pagination);
Vue.component("empty", Empty);
Vue.component("phone", Phone);
Vue.component("company-search", CompanySearch);
Vue.component("school-search", SchoolSearch);
Vue.component("company-filters", CompanyFilters);
Vue.component("search", Search);
